import { useEffect } from 'react';

const useJarallax = () => {
    useEffect(() => {
        // We need a variable to hold the library once it's imported
        let jarallaxLib;

        const init = async () => {
            const jarallaxElements = document.querySelectorAll('.jarallax');
            if (!jarallaxElements || jarallaxElements.length === 0) {
                return;
            }

            // Dynamically import the library
            const { jarallax } = await import('jarallax');

            // Store the library in our variable and initialize it
            jarallaxLib = jarallax;
            jarallaxLib(jarallaxElements, { speed: 0.2 });
        };

        init();

        // This is the cleanup function returned by useEffect.
        // It runs automatically when the component is removed from the page.
        return () => {
            if (jarallaxLib) {
                jarallaxLib(document.querySelectorAll('.jarallax'), 'destroy');
            }
        };
    }, []); // Use an empty dependency array [] to ensure this runs only once.
};

export default useJarallax;